import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function HandCoins({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M6.97 19.96H8.48C8.8 19.96 9.13 20 9.45 20.08L12.1 20.75C12.68 20.9 13.27 20.91 13.86 20.8L16.79 20.22C17.57 20.06 18.28 19.68 18.84 19.13L20.92 17.06C21.51 16.47 21.51 15.51 20.92 14.92C20.38 14.38 19.54 14.32 18.94 14.78L16.53 16.6C16.18 16.86 15.76 17 15.33 17H13L14.48 17C15.31 17 15.99 16.32 15.99 15.48V15.17C15.99 14.47 15.51 13.86 14.84 13.7L12.548 13.12C12.168 13.02 11.788 12.98 11.408 12.98C10.478 12.98 9.568 13.25 8.798 13.76L6.978 14.97M17.16 5.15002C18.26 6.25002 18.26 8.05002 17.16 9.16002C16.05 10.26 14.25 10.26 13.14 9.16002C12.03 8.05002 12.03 6.25002 13.14 5.14002C14.24 4.03002 16.04 4.03002 17.15 5.14002M14.63 4.37502C14.53 3.80502 14.27 3.26502 13.84 2.82502C12.73 1.71702 10.93 1.71702 9.827 2.82502C8.717 3.93302 8.717 5.72502 9.827 6.83502C10.517 7.52502 11.467 7.77502 12.357 7.61502M6 21H4C3.448 21 3 20.55 3 20V14C3 13.44 3.44 13 4 13H6C6.55 13 7 13.44 7 14V20C7 20.55 6.55 21 6 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default HandCoins;